import { render } from "./Libraries.vue?vue&type=template&id=236accdd&scoped=true"
import script from "./Libraries.vue?vue&type=script&lang=js"
export * from "./Libraries.vue?vue&type=script&lang=js"

import "./Libraries.vue?vue&type=style&index=0&id=236accdd&scoped=true&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236accdd"]])

export default __exports__